import React from 'react';

import { emptyArray } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';

import { ShipFromErrorBanner } from '../../../../containers/orders-drawer/sections/error-banner';
import AddOrderToBatchOrPrint from '../add-order-to-batch-or-print';
import { BulkRateAndCreate } from '../components/bulk-rate-and-create';
import OrdersHeader from '../orders-header';
import style from './multi-order-header.module.less';

/**
 * @typedef {object} OrdersRate
 * @property {string} code - The currency code.
 * @property {number} value - The rate value.
 * @property {string[]} errors - The list of errors.
 * @property {undefined|number} missingCostReviewDataCount - Number of orders missing cost review data.
 */

const defaultOrderRate = {
  value: 0,
  code: '',
  errors: emptyArray,
  missingCostReviewDataCount: undefined,
};

/**
 * @typedef {import('ui-components/components/button').ButtonClickHandler} ButtonClickHandler
 */

/**
 * @param {object} props - The component props.
 * @param {number} props.ordersCount - The count of orders.
 * @param {OrdersRate} props.ordersRate - The rate information for the orders.
 * @param {ButtonClickHandler} props.onGetRates - The function to call to get rates.
 * @param {undefined|string} props.marketplaceId - The marketplace ID.
 * @param {string[]} props.fulfillmentPlanIds - The list of fulfillment plan IDs.
 * @param {boolean} props.disableRateRefresh - Whether to disable rate refresh.
 * @param {boolean} props.isEligibleForBulkRecommendedRates - Whether the user is eligible for bulk recommended rates.
 * @param {boolean} props.isLoadingRates
 * @returns {React.JSX.Element}
 */
export const MultipleOrders = ({
  ordersCount = 0,
  ordersRate = defaultOrderRate,
  onGetRates = noop,
  marketplaceId = undefined,
  fulfillmentPlanIds = emptyArray,
  disableRateRefresh = false,
  isEligibleForBulkRecommendedRates = true,
  isLoadingRates = false,
}) => {
  const hasAnyRateErrors = ordersRate.errors.length > 0;

  return (
    <div>
      <div className={style['orders-header']}>
        <OrdersHeader marketplaceId={marketplaceId} ordersCount={ordersCount} />
        <div className={style['header-actions']}>
          <AddOrderToBatchOrPrint />
        </div>
      </div>
      <BulkRateAndCreate
        disableRateRefresh={disableRateRefresh}
        fulfillmentPlanIds={fulfillmentPlanIds}
        hasAnyRateErrors={hasAnyRateErrors}
        isEligibleForBulkRecommendedRates={isEligibleForBulkRecommendedRates}
        isLoadingRates={isLoadingRates}
        onGetRates={onGetRates}
        ordersRate={ordersRate}
      />
      <ShipFromErrorBanner fulfillmentPlanIds={fulfillmentPlanIds} />
    </div>
  );
};
